import '../styles/Wrap.css'
function Wrap({children}){
	return <section id="dataviz" className="onepage panel animate">{children}</section>
}

export default Wrap